import { Event, Subscription, VoucherIdentifiable } from 'inscreva-sse-models';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

import httpService from '@/services/http';

import { StoreSingleton } from '.';
import { sessionStore } from './session';

@Module({
  name: 'subscriptionStore',
  namespaced: true,
  stateFactory: true,
  dynamic: true,
  preserveState: true,
  store: StoreSingleton.getInstance(),
})
export default class SubscriptionStore extends VuexModule {
  private _subscription: Subscription;

  @Mutation
  fromJson(json: any) {
    this._subscription = Subscription.fromJson(json);
  }

  @Action
  async list(query?: Record<string, any>, event?: Event): Promise<Array<Subscription>> {
    return (
      await httpService(sessionStore.session).get(
        `/subscription/${event?.alias || sessionStore.session?.event?.alias}`,
        {
          params: query,
        },
      )
    ).data;
  }

  @Action
  async remove(id: string) {
    const { session } = sessionStore;
    const { alias } = session.event;
    await httpService(sessionStore.session).delete(`/subscription/${alias}/${id}`);
  }

  @Action({ rawError: true })
  async listVouchers(query: Record<string, any> = {}): Promise<Array<VoucherIdentifiable>> {
    return (
      await httpService(sessionStore.session).get(`/subscription/vouchers/${sessionStore.session?.event?.alias}`, {
        params: query,
      })
    ).data;
  }

  @Action({ rawError: true })
  async upsert(subscription: Subscription): Promise<Subscription> {
    const { session } = sessionStore;
    const { alias } = session.event;

    return (await httpService(sessionStore.session).put(`/subscription/${alias}`, subscription)).data;
  }

  @Action({ rawError: true })
  async activate(voucher: VoucherIdentifiable): Promise<Subscription> {
    const { session } = sessionStore;
    const { alias } = session.event;
    voucher.activated = true;

    return (await httpService(sessionStore.session).put(`/subscription/vouchers/${alias}`, voucher)).data;
  }

  @Action({ rawError: true })
  async searchBy(query: Record<string, any>): Promise<Subscription> {
    return (await this.list(query))[0];
  }

  get subscription(): Subscription {
    return this._subscription;
  }
}
